import styled from 'styled-components';
import { black, grey } from 'styles/Colors';

export const TeamNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TeamNameText = styled.span`
  font-family: Oswald;
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: ${black};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  &.away-team-name {
    margin-right: 13px;
  }
`;

export const TeamSide = styled.span`
  font-size: 11px;
  color: ${grey};
  text-transform: uppercase;
  font-family: Oswald;
  font-weight: 500;
`;
